module.exports = __webpack_public_path__ + "static/media/apr2025_ifrs.8155c10b.webp";